import React from "react";
import Layout from "../../Layout/Layout";
import Link from "next/link";
import { BsFillCartXFill, BsFillCheckCircleFill } from "react-icons/bs";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { useState } from "react";
import { useEffect } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import UnlogCart from "./UnlogCart";
import { MdRemoveShoppingCart } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  NativeSelect,
  Select,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";

const Cart = () => {
  let Navigate = useNavigate();

  // Load
  const [load, setLoad] = useState(false);

  // Items Quantity
  const [totalQuantity, setTotalQuantity] = useState([]);

  const [cartItem, setCartItem] = useState([]);
  const [totalItem, setTotalItem] = useState();
  const [totalPrice, setTotalPrices] = useState();

  const GetAllCartItems = async () => {
    setLoad(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_BASE_URL +
        `getby_customer_id/${localStorage.getItem("customer_id")}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("Cart Data FS :", result);
        setCartItem([...result.data]);
        setTotalQuantity(result.data[0].item_qty);
      })
      .catch((error) => console.log("error", error));
    setLoad(false);
  };

  // Filter only in-stock items
  const validCartItems = (cartItem || []).filter(
    (el) => el.var_in_stock !== "0" && el.products?.in_stock !== 0
  );

  // Subtotal: Count and Price
  const TotalPrice = validCartItems.reduce((accumulator, el) => {
    return accumulator + parseInt(el.total_price);
  }, 0);

  const TotalItem = validCartItems.reduce((accumulator, el) => {
    return accumulator + parseInt(el.item_qty);
  }, 0);

  useEffect(() => {
    setTotalPrices(TotalPrice);
    setTotalItem(TotalItem);
  }, [GetAllCartItems]);

  useEffect(() => {
    GetAllCartItems();
  }, []);

  const handleGoAddress = () => {
    setLoad(true);
    Navigate("/address");
  };

  // Group items by product_id
  const groupByProduct = (items) => {
    const grouped = {};
    items.forEach((item) => {
      const id = item.product_id;
      if (!grouped[id]) {
        grouped[id] = {
          ...item, // base product info
          variations: [
            {
              id: item.id,
              var_weight: item.var_weight,
              item_price: item.item_price,
              item_qty: item.item_qty,
              var_in_stock: item.var_in_stock,
            },
          ],
        };
      } else {
        grouped[id].variations.push({
          id: item.id,
          var_weight: item.var_weight,
          item_price: item.item_price,
          item_qty: item.item_qty,
          var_in_stock: item.var_in_stock,
        });
      }
    });
    return Object.values(grouped);
  };

  const groupedCartItems = groupByProduct(cartItem);

  const handleRemoveCartItems = async (id) => {
    // console.log("ID =>", id);
    var requestOptions = {
      method: "POST",
      redirect: "follow",
    };
    // console.log(id);
    await fetch(
      process.env.REACT_APP_BASE_URL + `DeleteCartItem/${id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          toast.success("Deleted successfully", {
            theme: "light",
            autoClose: "2000",
          });
        } else {
          toast.error("Something Went Wrong", {
            theme: "light",
            autoClose: "2000",
          });
        }
      })
      .catch((error) => console.log("error", error));

    await GetAllCartItems();
  };

  const [updatedQty, setUpdatedQty] = useState();

  const CartAddQuantity = async (el) => {
    let index = 0;
    // const values = [...cartItem];
    // values[index].item_qty = parseInt(el.item_qty) + 1;
    // setCartItem(values);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id: el.id,
      item_qty: parseInt(el.item_qty) + 1,
    });
    // console.log(raw);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(process.env.REACT_APP_BASE_URL + "updateQty", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);

        if (result.status === 200) {
          setCartItem(result.data);
        } else {
          toast.error("Something Went Wrong", {
            theme: "light",
            autoClose: "2000",
          });
        }
      })
      .catch((error) => console.log("error", error));
  };

  const CartMinusQuantity = async (el) => {
    let index = 0;
    // const values = [...cartItem];
    // values[index].item_qty = el.item_qty - 1;
    // setCartItem(values);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id: el.id,
      item_qty: el.item_qty - 1,
    });
    // console.log(raw);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(process.env.REACT_APP_BASE_URL + "updateQty", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        setCartItem(result.data);
        if (result.status === 200) {
        } else {
          toast.error("Something Went Wrong", {
            theme: "light",
            autoClose: 2000,
          });
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleNavigateProductDetail = (el) => {
    localStorage.setItem("Product ID", el.product_id);
    // console.log("Cart Data FS: ", el.products.product_name);
    const formattedProductName = el.products.product_name
      .toLowerCase() // Step 1: Convert to lowercase
      .replace(/\s+/g, "-") // Step 2: Replace spaces with dashes
      .replace(/[^a-z0-9-]/g, ""); // Remove any non-alphanumeric characters except hyphens

    Navigate(`/Product/${formattedProductName}`, {
      state: { id: el.product_id }, // Pass the id in state
    });
  };

  return (
    <>
      {/* {console.log(cartItem.length)} */}
      {load ? (
        <div className="h-screen bg-white"></div>
      ) : (
        <Layout>
          <div className="">
            <div className="flex flex-col md:flex-col lg:flex-row p-1 md:p-10 lg:p-10">
              <div className="bg-white rounded-2xl w-full mb-5 shadow-sm">
                <div className="px-5 py-6 md:px-10 font-bold text-2xl md:text-3xl">
                  Shopping Cart
                </div>
                <hr className="border-[1px] mx-5 border-[#008000]" />

                {groupedCartItems.length > 0 ? (
                  groupedCartItems.map((el, index) => (
                    <div key={index} className="p-4 md:p-6">
                      <div className="flex flex-col md:flex-row md:items-start md:space-x-6">
                        {/* 🖼️ Product Image */}
                        <div
                          className="flex-shrink-0 mx-auto md:mx-0 cursor-pointer"
                          onClick={() => {
                            if (
                              el.products?.is_active === 1 &&
                              el.var_in_stock === "1"
                            ) {
                              handleNavigateProductDetail(el);
                            }
                          }}
                        >
                          <img
                            src={
                              process.env.REACT_APP_MEDIA_BASE_URL +
                              el.products.product_base_image
                            }
                            alt="azamDeal"
                            className="object-contain h-40 w-40 md:h-44 md:w-44 rounded-lg"
                          />
                        </div>

                        {/* 📦 Product Details */}
                        <div className="flex flex-col justify-between w-full mt-4 md:mt-0">
                          <div>
                            <p className="font-bold text-lg md:text-xl text-gray-900">
                              {el.products.product_name}
                            </p>
                            <p className="text-sm text-gray-600 mt-1">
                              {el.products.product_desc.slice(0, 100)}
                            </p>
                          </div>

                          {/* 🧩 Variations */}
                          <div className="mt-3 space-y-3">
                            {el.variations.map((variant) => (
                              <div
                                key={variant.id}
                                className="flex flex-col sm:flex-row sm:items-center sm:justify-between border border-gray-100 rounded-xl p-3 shadow-sm"
                              >
                                {/* Weight & Price */}
                                <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
                                  <span className="text-sm font-semibold text-gray-700">
                                    Weight: {variant.var_weight}
                                  </span>
                                  <span className="text-sm text-[#008000] font-semibold mt-1 sm:mt-0">
                                    ₹{variant.item_price}.00
                                  </span>
                                </div>

                                {/* Qty Controls + Remove */}
                                <div className="flex flex-wrap sm:flex-nowrap items-center justify-between sm:justify-end mt-3 sm:mt-0 sm:space-x-4">
                                  <div className="flex items-center border border-emerald-200 rounded-md p-1 text-[#008000]">
                                    <button
                                      onClick={() => CartMinusQuantity(variant)}
                                      disabled={variant.item_qty < 2}
                                    >
                                      <AiOutlineMinus className="text-lg mx-2" />
                                    </button>
                                    <span className="text-center text-black px-3 border-x border-[#008000]">
                                      {parseInt(variant.item_qty)}
                                    </span>
                                    <button
                                      onClick={() => CartAddQuantity(variant)}
                                    >
                                      <AiOutlinePlus className="text-lg mx-2" />
                                    </button>
                                  </div>

                                  <button
                                    onClick={() =>
                                      handleRemoveCartItems(variant.id)
                                    }
                                    className="text-red-500 hover:underline text-sm mt-2 sm:mt-0"
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <hr className="border-t border-gray-200 mt-5" />
                    </div>
                  ))
                ) : (
                  <div className="bg-white p-5 rounded-2xl w-full flex flex-col items-center justify-center text-center">
                    <MdRemoveShoppingCart className="text-7xl text-gray-400 mb-4" />
                    <p className="text-lg font-semibold text-gray-700">
                      <span className="font-bold">No items available!</span>
                      <br />
                      Please add items to your cart.
                    </p>
                  </div>
                )}
              </div>
              <div className="lg:block sticky top-28 p-5 md:p-10 bg-white ml-5 md:ml-10 h-64 rounded-2xl shadow-xl">
                <BsFillCheckCircleFill className="text-sm text-[#008000]" />
                <span className="text-center text-sm text-[#008000]">
                  Orders Above 499/- are eligible for free Delivery.
                </span>
                <p className="text-xl font-semibold mt-2">
                  SubTotal:{" "}
                  <span>
                    ({totalItem} {""} Items):{" "}
                    <span className="font-bold text-[#008000]">
                      {"₹" + totalPrice + "/-"}
                    </span>
                  </span>
                </p>

                <div className="mt-5">
                  <button
                    type="submit"
                    className="w-full p-2 bg-[#008000] hover:bg-green-600 text-white rounded-md font-semibold disabled:bg-gray-400"
                    onClick={handleGoAddress}
                    disabled={
                      cartItem.length === 0 ||
                      cartItem.some((item) => item.products.in_stock === 0) ||
                      cartItem.some((item) => item.var_in_stock === "0") ||
                      cartItem.some((item) => item.products.is_active === 0)
                    }
                  >
                    Proceed to Checkout
                  </button>

                  {(cartItem.some((item) => item.products.in_stock === 0) ||
                    cartItem.some((item) => item.var_in_stock === "0")) && (
                    <p className="text-red-500 text-sm mt-2">
                      Some items are out of stock. Please remove them to
                      proceed.
                    </p>
                  )}

                  {cartItem.some((item) => item.products.is_active === 0) && (
                    <p className="text-yellow-500 text-sm mt-2">
                      Some products are inactive. Please remove them to proceed.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={load}
          >
            <CircularProgress color="success" />
          </Backdrop>
          <ToastContainer />
        </Layout>
      )}
    </>
  );
};

export default Cart;
